<template>
  <div>
    <div class="top">
      <img src="../../assets/petition/competition.png" alt="" />
    </div>
    <div class="switch">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="copen.matchTypeName"
          :name="copen.matchTypeId"
          v-for="(copen, index) in titleList"
          :key="index"
        >
          <div class="tab-left">
            <div v-if="people.length > 0">
              <table
                style="
                  width: 100%;
                  border-spacing: 0px;
                  border-collapse: collapse;
                "
                v-if="num !== 0"
              >
                <tr style="border: none; background-color: #e5f6ff">
                  <td style="width: 15%; text-align: center">{{ myRank }}</td>
                  <td style="width: 20%; text-align: left">
                    <img
                      :src="
                        memberExamInfo.headImg
                          ? male[memberExamInfo.headImg].img
                          : male[0].img
                      "
                      alt=""
                    />
                    <!-- <img v-if="memberExamInfo.sex===1"  :src="female[memberExamInfo.headImg].img" alt=""/>
                                        <img v-if="memberExamInfo.sex===2"  src="../../assets/home/44.png" alt=""/> -->
                    {{ memberExamInfo.name }}
                  </td>
                  <td style="width: 10%; text-align: center; color: #1f9cfb">
                    我
                  </td>
                  <td style="width: 35%; text-align: center; color: #1f9cfb">
                    {{ memberExamInfo.readEfficiency }}字/分钟
                  </td>
                  <td style="width: 20%; text-align: center; color: #1f9cfb">
                    {{ memberExamInfo.readSpeed }}字/分钟
                  </td>
                </tr>
              </table>
              <table
                style="
                  width: 100%;
                  border-spacing: 0px;
                  border-collapse: collapse;
                "
              >
                <thead>
                  <tr style="border: none">
                    <th style="width: 10%">排名</th>
                    <th style="width: 20%">班级</th>
                    <th style="width: 15%">姓名</th>
                    <th style="width: 10%">分数</th>
                    <th style="width: 20%">阅读效率</th>
                    <th style="width: 20%">阅读速度</th>
                  </tr>
                </thead>
              </table>
              <div class="slide">
                <table
                  style="
                    width: 100%;
                    border-spacing: 0px;
                    border-collapse: collapse;
                  "
                >
                  <tbody>
                    <tr
                      v-for="(person, ins) in people"
                      :key="ins"
                      style="border: none"
                      @click="replacestring(person)"
                    >
                      <td style="width: 10%; text-align: center">
                        <div v-if="activeName === '1'" class="badgeImg">
                          <img
                            v-if="ins === 0"
                            src="../../assets/badge/zhou1.png"
                            alt=""
                          />
                          <img
                            v-else-if="ins === 1"
                            src="../../assets/badge/zhou3.png"
                            alt=""
                          />
                          <img
                            v-else-if="ins === 2"
                            src="../../assets/badge/zhou2.png"
                            alt=""
                          />
                          <span v-else>{{ ins + 1 }}</span>
                        </div>
                        <div v-else-if="activeName === '2'" class="badgeImg">
                          <img
                            v-if="ins === 0"
                            src="../../assets/badge/yue1.png"
                            alt=""
                          />
                          <img
                            v-else-if="ins === 1"
                            src="../../assets/badge/yue3.png"
                            alt=""
                          />
                          <img
                            v-else-if="ins === 2"
                            src="../../assets/badge/yue2.png"
                            alt=""
                          />
                          <span v-else>{{ ins + 1 }}</span>
                        </div>
                        <div v-else-if="activeName === '3'" class="badgeImg">
                          <img
                            v-if="ins === 0"
                            src="../../assets/badge/ji1.png"
                            alt=""
                          />
                          <img
                            v-else-if="ins === 1"
                            src="../../assets/badge/ji2.png"
                            alt=""
                          />
                          <img
                            v-else-if="ins === 2"
                            src="../../assets/badge/ji3.png"
                            alt=""
                          />
                          <span v-else>{{ ins + 1 }}</span>
                        </div>
                        <div v-else-if="activeName === '4'" class="badgeImg">
                          <img
                            v-if="ins === 0"
                            src="../../assets/badge/nian1.png"
                            alt=""
                          />
                          <img
                            v-else-if="ins === 1"
                            src="../../assets/badge/nian2.png"
                            alt=""
                          />
                          <img
                            v-else-if="ins === 2"
                            src="../../assets/badge/nian3.png"
                            alt=""
                          />
                          <span v-else>{{ ins + 1 }}</span>
                        </div>
                        <span v-else>{{ ins + 1 }}</span>
                      </td>
                      <td style="width: 20%; text-align: center">
                        {{ person.group.split("/")[1]
                        }}{{ person.group.split("/")[2] }}
                      </td>
                      <td style="width: 15%; text-align: left">
                        <img
                          :src="
                            person.headImg
                              ? male[person.headImg].img
                              : male[0].img
                          "
                          alt=""
                        />
                        {{ person.name }}
                      </td>
                      <td style="width: 10%; text-align: center">
                        {{ person.readScore }}分
                      </td>
                      <td style="width: 20%; text-align: center">
                        {{ person.readEfficiency }}字/分钟
                      </td>
                      <td style="width: 20%; text-align: center">
                        {{ person.readSpeed }}字/分钟
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
              <el-empty :image-size="200"></el-empty>
            </div>
          </div>
          <div class="tab-right">
            <div class="rImg" :style="{ height: xuanzhong.height }">
              <img :src="xuanzhong.img" alt="" @click="commence" />
              <div class="oning" @click="jumpDetails" v-if="activeName === '5'">
                ＊查看活动规则
              </div>
            </div>
            <div
              class="riBot"
              v-if="activeName !== '5'"
              :style="{ background: xuanzhong.background }"
            >
              <span>{{ xuanzhong.title }}</span>
              <p @click="jumpDetails">{{ xuanzhong.rule }}</p>
              <div class="medal">
                <img :src="xuanzhong.image" alt="" />
                <!-- <img v-if="ins===0" src="../../assets/badge/ji1.png" alt="">
                                  <img v-else-if="ins===1" src="../../assets/badge/ji2.png" alt="">
                                  <img v-else-if="ins===2" src="../../assets/badge/ji3.png" alt=""> -->
                <span v-if="!memberExamInfo.name">未获得</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <bagePorp
      :textmsg="textbadPor"
      @clickBttn="clickBttn"
      v-if="badPorp"
    ></bagePorp>
    <prompt @porione="porione" v-if="point"></prompt>

    <el-dialog
      :title="roueFet.title"
      :visible.sync="centerDialogVisible"
      width="300px"
      :showClose="false"
      :close-on-click-modal="false"
      center
    >
      <p><span>总时间：</span>-分钟</p>
      <p><span>字数：</span>1820字</p>
      <!-- <span class="sdfe">{{roueFet.prompt}}</span>
            <img class="dia-img" :src="roueFet.img" alt="" v-if="roueFet.stype===2"> -->
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
        <button class="confirmButton" @click="confirm(roueFet.stype)">
          {{ roueFet.butText }}
        </button>
      </span>
    </el-dialog>
    <my-footer></my-footer>
  </div>
</template>

<script>
import { type } from "os";
import { throttle } from "../../components/throttle";
import bagePorp from "./components/badge-porp.vue";
import myFooter from "../../components/footer.vue";
import prompt from "./components/prompt.vue";
import {
  getPetition,
  getCreate,
  getVerify,
  getShuFfle,
  getActivity,
  ExamRanking,
  SearchMedal,
} from "@/api/petition/index";
import screenfull from "screenfull";
export default {
  components: {
    bagePorp,
    prompt,
    myFooter,
  },
  data() {
    return {
      myRank: "未上榜",
      count: 0,
      userInfo: "",
      loading: false,
      totalPages: "", //取后端返回内容的总页数
      list: [], //后端返回的数组
      activeName: "1",
      titleList: [
        { name: "周赛", id: "1" },
        { name: "月赛", id: "2" },
        { name: "季赛", id: "3" },
        { name: "年赛", id: "4" },
        { name: "活动", id: "5" },
      ],
      memberExamInfo: {},
      num: "",
      people: [],
      baColor: [
        {
          img: require("../../assets/petition/1.png"),
          image: require("../../assets/badge/zhou4.png"),
          title: "完成周赛即可获得周赛荣誉勋章",
          rule: "＊查看周赛规则",
          background: "#FDF3DD",
          height: "31.4vh",
        },
        {
          img: require("../../assets/petition/2.png"),
          image: require("../../assets/badge/yue4.png"),
          title: "完成月赛即可获得月赛荣誉勋章",
          rule: "＊查看月赛规则",
          background: "#D6EFFA",
          height: "31.4vh",
        },
        {
          img: require("../../assets/petition/3.png"),
          image: require("../../assets/badge/ji4.png"),
          title: "完成季赛即可获得季赛荣誉勋章",
          rule: "＊查看季赛规则",
          background: "#E8F2FF",
          height: "31.4vh",
        },
        {
          img: require("../../assets/petition/4.png"),
          image: require("../../assets/badge/nian4.png"),
          title: "完成年赛即可获得年赛荣誉勋章",
          rule: "＊查看年赛规则",
          background: "#F4F3FE",
          height: "31.4vh",
        },
        {
          img: require("../../assets/petition/5.png"),
          title: "",
          background: "",
          height: "49vh",
        },
      ],
      male: [
        {
          img: require("../../assets/sculpture/girl1.png"),
          selected: false,
        },
        {
          img: require("../../assets/sculpture/girl2.png"),
          selected: false,
        },
        {
          img: require("../../assets/sculpture/girl3.png"),
          selected: false,
        },
        {
          img: require("../../assets/sculpture/girl4.png"),
          selected: false,
        },
        {
          img: require("../../assets/sculpture/girl5.png"),
          selected: false,
        },
        {
          img: require("../../assets/sculpture/girl5.png"),
          selected: false,
        },
        {
          img: require("../../assets/sculpture/boy1.png"),
          selected: false,
        },
        {
          img: require("../../assets/sculpture/boy2.png"),
          selected: false,
        },
        {
          img: require("../../assets/sculpture/boy3.png"),
          selected: false,
        },
        {
          img: require("../../assets/sculpture/boy4.png"),
          selected: false,
        },
        {
          img: require("../../assets/sculpture/boy5.png"),
          selected: false,
        },
        {
          img: require("../../assets/sculpture/boy6.png"),
          selected: false,
        },
      ],
      female: [],
      xuanzhong: "",
      // 排行弹窗
      badPorp: false,
      textbadPor: {},
      //未解锁弹窗
      point: false,
      centerDialogVisible: false,
      roueFet: {
        title: "一千张糖纸",
        img: "",
        stype: 1, //控制开始图片显示不显示
        butText: "开始训练",
      },
      selectedIndex: "",
    };
  },
  created() {
    let infor = JSON.parse(sessionStorage.getItem("userInfo"));
    if (infor !== null) {
      this.userInfo = infor;
    }
    this.enterPage();
    this.xuanzhong = this.baColor[0];
    //获取当前时间
    let date = new Date();
    //年 getFullYear()：四位数字返回年份
    let year = date.getFullYear(); //getFullYear()代替getYear()
    //月 getMonth()：0 ~ 11
    let month = date.getMonth() + 1;
    //日 getDate()：(1 ~ 31)
    let day = date.getDate();
    let timese = null;
    timese = year + "-" + this.addZero(month);
    this.nuberOne(timese);
    screenfull.exit();
  },
  methods: {
    enterPage() {
      getPetition().then((res) => {
        for (let item of res.rows) {
          item.matchTypeId = item.matchTypeId.toString();
        }
        this.titleList = res.rows;
      });
    },
    handleClick(tab, event) {
      this.memberExamInfo = {};
      let index = tab.index;
      // console.log(typeof(index))
      this.selectedIndex = index;
      this.xuanzhong = this.baColor[index];
      //获取当前时间
      var date = new Date();
      //年 getFullYear()：四位数字返回年份
      var year = date.getFullYear(); //getFullYear()代替getYear()
      //月 getMonth()：0 ~ 11
      var month = date.getMonth() + 1;
      //日 getDate()：(1 ~ 31)
      var day = date.getDate();
      let time = null;
      if (index === "0") {
        time = year + "-" + this.addZero(month);
        this.nuberOne(time);
      } else if (index === "1") {
        time = year + "-" + this.addZero(month - 1);
        this.nuberOne(time);
      } else if (index === "2") {
        let a = ["06", "07", "08"];
        let b = ["09", "10", "11"];
        let c = ["12", "01", "02"];
        let d = ["03", "04", "05"];
        if (a.indexOf(month) == -1) {
          time = year + "-" + "05";
        } else if (b.indexOf(month) == -1) {
          time = year + "-" + "08";
        } else if (c.indexOf(month) == -1) {
          time = year + "-" + "11";
        } else if (d.indexOf(month) == -1) {
          time = year + "-" + "02";
        }
        this.nuberOne(time);
      } else if (index === "3") {
        time = year;
        this.nuberOne(time);
      } else if (index === "4") {
        time = year;
        let user = this.userInfo;
        let data = {
          state: 2,
          type: 2,
        };
        getActivity(data.state, data.type).then((res) => {
          if (res.data != undefined) {
            let data = {
              examId: res.data,
              pageSize: 50,
              code: 3,
              memberId: user.memberId,
            };
            ExamRanking(data).then((response) => {
              this.num = response.data.num;
              if (response.data.readExamResults !== undefined) {
                this.memberExamInfo = response.data.memberExamInfo;
                for (var item of response.data.readExamResults) {
                  if (item.headImg === null) {
                    item.headImg = 0;
                  }
                }
                this.people = response.data.readExamResults;
                // 自己排行名次
                this.people.forEach((item, index) => {
                  if (item.name == this.memberExamInfo.name)
                    this.myRank = index + 1;
                });
              } else {
                this.people = [];
              }
            });
          } else {
            this.people = [];
          }
        });
      }
    },
    //小于10的拼接上0字符串
    addZero(s) {
      return s < 10 ? "0" + s : s;
    },
    // 获取排行
    nuberOne(val) {
      let user = this.userInfo;
      let data = {
        type: this.activeName,
        memberId: user.memberId,
        pageSize: 50,
        time: val,
        code: 3,
      };
      getShuFfle(data).then((res) => {
        this.num = res.data.num;
        if (res.data.readExamResults != undefined) {
          this.memberExamInfo = res.data.memberExamInfo;
          for (var item of res.data.readExamResults) {
            if (item.headImg === null) {
              item.headImg = 0;
            }
          }
          this.people = res.data.readExamResults;
          // 自己排行名次
          this.people.forEach((item, index) => {
            if (item.name == this.memberExamInfo.name) this.myRank = index + 1;
          });
        } else {
          this.people = [];
        }
      });
    },
    // 排名行点击事件
    replacestring(item) {
      let obj = {
        memberId: item.memberId,
        code: 3,
      };
      SearchMedal(obj).then((res) => {
        this.textbadPor = res.data;
        this.textbadPor.group = item.group;
        this.badPorp = true;
      });
    },
    clickBttn() {
      this.badPorp = false;
    },

    porione() {
      this.point = false;
    },
    // 点击开始比赛图片事件
    commence: throttle(function () {
      let mous = JSON.parse(sessionStorage.getItem("autonomous"));
      if (mous.competitionStatus === 0) {
        this.$message({
          message: "没有比赛权限",
          type: "warning",
          showClose: true,
        });
        return;
      }
      let uId = this.userInfo;
      let obj = {
        memberId: uId.memberId,
        type: this.activeName,
      };
      getVerify(obj).then((res) => {
        if (res.msg !== "操作成功") {
          this.$message({
            message: res.msg,
            type: "warning",
            showClose: true,
          });
        } else {
          this.$router.push({
            path: "/start",
            query: {
              status: this.activeName,
            },
          });
        }
      });
    }, 3000),
    confirm(eq) {
      this.centerDialogVisible = false;
    },

    //查看比赛规则事件
    jumpDetails() {
      // activeName
      this.$router.push({
        path: "/petiDetails",
        query: {
          state: this.activeName,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  width: 100%;
  height: 41vh;
  img {
    width: 100%;
    height: 40vh;
  }
}
.switch {
  width: 70%;
  height: 60vh;
  margin: 0 auto;
}

@media (max-width: 1300px) {
  .switch {
    width: 90%;
  }
}
tr > th {
  color: #b5b8bd;
  height: 40px;
  font-size: 13px;
}
tr > td {
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #efefef;
}
tr > td > img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  vertical-align: middle;
}
.badgeImg img {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  vertical-align: middle;
}

.tab-left {
  width: 65%;
  height: 49vh;
  float: left;
  padding-right: 10px;
  box-sizing: border-box;
}
.tab-right {
  width: 35%;
  height: 49vh;
  float: left;
  .rImg {
    width: 100%;
    position: relative;
    img {
      width: inherit;
      height: inherit;
    }
    .oning {
      height: 5vh;
      line-height: 5vh;
      color: #14b9f6;
      cursor: pointer;
      position: absolute;
      left: 35%;
      bottom: 10px;
      font-size: 1.8vh;
    }
  }

  .riBot {
    width: 100%;
    height: 14vh;
    background: #fdf3dd;
    border-radius: 10px;
    padding: 0 15px;
    margin-top: 5vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    position: relative;
    span {
      font-size: 1.8vh;
    }
    p {
      color: #14b9f6;
      width: 120px;
      font-size: 1.6vh;
      padding: 6px 10px;
      border-radius: 20px;
      background: #ffffff;
      cursor: pointer;
    }
    .medal {
      width: 13vh;
      height: 13vh;
      position: absolute;
      top: 0;
      right: 0;
      img {
        width: 13vh;
        height: 13vh;
      }
      span {
        color: #9e9e9e;
        display: block;
        background: #d9d9d9;
        width: 70px;
        text-align: center;
        border-radius: 30px;
        position: absolute;
        left: 25%;
        bottom: 8px;
      }
    }
  }
}
.slide {
  height: 44vh;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.slide::-webkit-scrollbar {
  display: none;
}
.confirmButton {
  width: 193px;
  height: 50px;
  border: none;
  border-radius: 30px;
  color: #ffffff;
  font-size: 18px;
  background: linear-gradient(to right, #2d85ff, #2da5ff, #2dbeff);
}
::v-deep .el-dialog {
  display: flex;
  display: -ms-flex; /* 兼容IE */
  flex-direction: column;
  -ms-flex-direction: column; /* 兼容IE */
  margin: 0 !important;
  border-radius: 20px !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  max-height: 100%;
  flex: 1;
  -ms-flex: 1 1 auto; /* 兼容IE */
  overflow-y: auto;
  overflow-x: hidden;
  text-align: center;
  font-size: 18px;
}

::v-deep .el-dialog__wrapper {
  /*隐藏ie和edge中遮罩的滚动条*/
  overflow: hidden;
}

::v-deep .customClass {
  background: #2d92ff;
  box-sizing: border-box;
  border: 1px solid #ffffff;
  .el-dialog__header {
    padding: 0 !important;
  }
}
::v-deep .el-progress-bar {
  width: 99%;
}
::v-deep .el-form-item {
  margin-bottom: 0;
}
</style>